import React, {useState} from "react";
import {Wrap, Shadow, Cinta} from "./styles";

export default function Bannerone() {
  const [isPopUpOpen, setPopUpOpen] = useState(false);

  return (
    <Wrap>
      <Cinta>
        <div>
          <h2>
            CAMBIAMO INSIEME IL FUTURO, <br />
            UNA CLASSE PER VOLTA
          </h2>
          <p>
            La sfida ai cambiamenti climatici ci pone di fronte al vero significato dell’essere cittadini del mondo.
            Nelle sezioni qui sotto trovi tutti gli strumenti necessari per trasformare i tuoi alunni in veri e propri
            “Agenti 0 emissioni”.
          </p>
        </div>
        <div>
          <p>
            <span>Caro docente,</span> <br />
            questo kit didattico è stato pensato per accompagnare te e i tuoi studenti in una missione importantissima:
            scopri come usarlo.
          </p>
          <button onClick={() => setPopUpOpen(!isPopUpOpen)}>LEGGI LA LETTERA</button>
        </div>
      </Cinta>
      {isPopUpOpen && (
        <Shadow onClick={() => setPopUpOpen(!isPopUpOpen)}>
          <div>
            <span onClick={() => setPopUpOpen(!isPopUpOpen)}>CHIUDI</span>
            <article>
              Caro insegnante, <br />
              <br />
              questo kit didattico è stato pensato per accompagnare te e i tuoi studenti in una missione
              importantissima: affrontare i cambiamenti climatici una scuola alla volta, partendo dalla tua classe! Per
              realizzare questo piano ambizioso, vi aiuteremo ad addestrare dei veri <label>“Agenti 0 emissioni”</label>
              , pronti a cambiare le proprie abitudini all’insegna della sostenibilità nella vita quotidiana e a far
              sentire la propria voce in modo che i cambiamenti climatici diventino un tema all’ordine del giorno sulle
              scrivanie di chi prende decisioni importanti per il futuro di tutti noi. <br />
              <br />
              Prima di passare all’azione, gli Agenti devono acquisire informazioni, competenze e anche un po’ di
              coraggio. Come sai, infatti, la consapevolezza e la spinta ad agire non possono nascere se non ci sono
              conoscenza e comprensione dei fenomeni. Questo kit ti aiuterà a far crescere una squadra di “Agenti 0
              emissioni” nutrendoli con sapere, speranza e motivazione per affrontare la sfida più grande del nostro
              tempo: la crisi climatica.
              <br />
              <br />
              Il kit che stai per scoprire è stato quindi pensato per accompagnare i tuoi studenti in questo percorso,
              attraverso tre passi fondamentali: <br />
              <br />
              1. <label>Imparare.</label> La scienza dei cambiamenti climatici. <br />
              2. <label>Capire.</label> Vivere in un Pianeta più caldo. <br />
              3. <label>Agire.</label> Strumenti e pratiche per passare all’azione. <br />
              <br />
              Questi tre passi o macro aree, in cui è suddiviso il kit, includono argomenti che variano dall’ambito
              scientifico a quello socio-economico, al fine di comprendere meglio tutti gli effetti dei cambiamenti
              climatici. All’interno di ciascuna area <label>troverai lezioni “pronte all’uso”</label>, da utilizzare in
              classe o da consegnare per lo studio a casa, <label>quiz finali e attività ludico-didattiche</label> da
              fare con gli studenti. <label>Le lezioni sono declinate su due target d’età:</label> per la scuola
              primaria (9-11 anni) e per la scuola secondaria di primo grado (12-14 anni). I contenuti sono in linea con
              il nucleo tematico dello sviluppo sostenibile dell’insegnamento trasversale dell’educazione civica. Le
              prime due sezioni (Imparare e Capire) hanno lo scopo di preparare gli “Agenti” alla vera missione di
              cambiamento, realizzabile grazie ai materiali della terza sezione (Agire), dove con attività pratiche
              potrete lavorare su due obiettivi: ridurre l’impronta carbonica della scuola e contribuire alla
              comunicazione della crisi climatica. Ogni sezione si conclude con un attestato che riconosce l’impegno
              della classe e il risultato ottenuto.
              <br />
              <br />
              Di seguito l’elenco dei contenuti del kit didattico, divisi per sezione. <br />
              <br />
              <label>1.Imparare:</label>
              <ul>
                <li>Video lezione introduttiva, che sintetizza i principali contenuti tematici della sezione</li>
                <li>
                  Lezione 1.1 - I cambiamenti climatici nella storia della Terra - Formato: presentazione interattiva da
                  usare in classe
                </li>
                <li>
                  Lezione 1.2 - Come si studiano i cambiamenti climatici - Formato: scheda da stampare e distribuire +
                  scheda con attività didattica da svolgere in classe
                </li>
                <li>
                  Lezione 1.3 - Cambiamenti climatici e biodiversità - Formato: scheda da stampare e distribuire +
                  scheda per docenti con attività didattica
                </li>
                <li>
                  Lezione 1.4 - Tra mitigazione e adattamento: le risposte ai cambiamenti climatici - Formato:
                  presentazione interattiva da usare in classe
                </li>
                <li>Quiz su tutti gli argomenti trattati nelle lezioni</li>
                <li>Infografiche da stampare e appendere in classe</li>
                <li>Attestato finale per la classe</li>
              </ul>{" "}
              <br />
              <br />
              <label>2. Capire:</label>
              <ul>
                <li>Video lezione introduttiva, che sintetizza i principali contenuti tematici della sezione</li>
                <li>Lezione 2.1 - Ingiustizie climatiche - Formato: presentazione interattiva da usare in classe</li>
                <li>
                  Lezione 2.2 - Guerre climatiche e migrazioni ambientali - Formato: presentazione interattiva da usare
                  in classe
                </li>
                <li>
                  Lezione 2.3 - I diritti dei bambini e la crisi climatica - Formato: scheda da stampare e distribuire +
                  scheda per docenti con attività didattica da svolgere in classe
                </li>
                <li>Quiz su tutti gli argomenti trattati nelle lezioni</li>
                <li>Infografiche da stampare e appendere in classe</li>
                <li>Attestato finale per la classe</li>
              </ul>{" "}
              <br />
              <br />
              <label>3. Agire:</label>
              <ul>
                <li>
                  Lezione 3.1 - Missione: riduzione. Arma segreta: risparmio energetico - Formato: presentazione
                  interattiva + scheda per docenti con proposta di attivazione
                </li>
                <li>
                  Lezione 3.2 - Missione: riduzione. Arma segreta: mobilità sostenibile - Formato: presentazione
                  interattiva + scheda per docenti con proposta di attivazione
                </li>
                <li>
                  Lezione 3.3 - Missione: fai sentire la tua voce. Arma segreta: parlare in pubblico - Formato: scheda
                  ad uso dei docenti
                </li>
                <li>
                  Lezione 3.4 - Missione: fai sentire la tua voce. Arma segreta: advocacy - Formato: presentazione
                  interattiva + proposta di attivazione
                </li>
                <li>
                  Lezione 3.5 - Missione: fai sentire la tua voce. Arma segreta: il dibattito - Formato: scheda ad uso
                  dei docenti
                </li>
                <li>Attestato personale finale</li>
              </ul>{" "}
              <br />
              <br />
              All’interno del kit troverai inoltre una sezione di approfondimento: una selezione di link a video,
              articoli, siti web, libri e film. <br />
              <br />
              <br />
              Questo kit servirà non solo ad aumentare la conoscenza e la consapevolezza degli studenti, ma soprattutto
              ad aiutarli a comprendere meglio cosa possono fare per concretizzare un vero cambiamento. Mentre noi
              fatichiamo ad adattarci ai cambiamenti climatici, la Terra lo fa da milioni di anni. Anche l'economia e la
              società possono cambiare e i ragazzi hanno bisogno di mettere a fuoco il loro ruolo da protagonisti
              all’interno di questo complesso sistema.
              <br />
              <br />
              <label>
                La sfida ai cambiamenti climatici ci pone di fronte al vero significato dell’essere cittadini del mondo!
              </label>
              <br />
              <br />
              Buona missione!
              <br />
              <br />
              <span>Il team di Istituto Oikos</span>
              <br /> <br />
              <span>
                I contenuti di questo kit sono stati realizzati dal personale di Istituto Oikos, con la supervisione
                scientifica di Stefano Caserini, ingegnere ambientale e professore di Mitigazione dei Cambiamenti
                Climatici presso il Politecnico di Milano e Gianluca Ruggieri, ingegnere ambientale e ricercatore presso
                il Dipartimento di Scienze Teoriche e Applicate dell’Università degli Studi dell’Insubria.
              </span>
            </article>
          </div>
        </Shadow>
      )}
    </Wrap>
  );
}
